import { Spin } from 'antd';
import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useSession } from './useSession';

/** Chặn route: chưa đăng nhập -> chuyển tới /login. */
export function AuthGuard({ children }: { children: ReactNode }): JSX.Element {
  const { data: user, isLoading } = useSession();
  const location = useLocation();

  if (isLoading) {
    return <Spin fullscreen tip="Đang kiểm tra phiên đăng nhập..." />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return <>{children}</>;
}
